import React, { FC, useEffect, useState } from 'react'
import { Message } from "@/utils";
import {DepartmentHeadRecommendationApi} from "@/api";
import DepartmentHeadRecommendationView from "./DepartmentHeadRecommendationView.view";
import DrawerView from '@/components/Drawer/DrawerView';
import {useErrorHandler} from "@/hooks/useErrorHandler";

const initialState = {
    modalTitle: 'Progress Report Info',
    itemData: {id: null},
    loading: false,
    fields: {},
}

const DepartmentHeadRecommendationViewController: FC<any> = props => {
    const { entityId, reloadView, isShowView, handleCallbackFunc } = props;
    const modalTitle = initialState.modalTitle;
    const [itemData, setItemData] = useState(initialState.itemData);
    const [loading, setLoading] = useState(initialState.loading);
    const { handleErrorMessage, handleSuccessMessage, showErrorMessage } = useErrorHandler();

    useEffect(() => {
        setItemData(initialState.itemData);
        if (entityId && isShowView) {
            loadData();
        }
    }, [entityId, reloadView])

    const loadData = (): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoading(true);
            DepartmentHeadRecommendationApi.getById(entityId)
                .then(res => {
                    setItemData(res.data.data);
                    setLoading(false);
                    resolve(res);
                })
                .catch(err => {
                    handleErrorMessage(err);
                    setLoading(false);
                    reject(err);
                });
        });
    }

    return (
        <DrawerView
            drawerWidth={'60%'}
            loading={loading}
            reloadView={reloadView}
            isShowView={isShowView}
            modalTitle={modalTitle}
            itemData={itemData}
            component={DepartmentHeadRecommendationView}
            handleCallbackFunc={handleCallbackFunc}
        />
    );
}

export default React.memo(DepartmentHeadRecommendationViewController);
